<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['sell_medicine']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <div class="card-body">
                    <form @submit.prevent="AddtoCart">
                      <div class="form-group mb-2">
                        <label>Category</label>
                        <multiselect v-model="category" label="name" @input="FilterProducts" :options="productcategories"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Product</label>
                        <multiselect v-model="product" label="name" @input="FilterProductUnits" :options="products"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Unit</label>
                        <multiselect v-model="unit" label="unit" @input="updateSalePreview" :options="units"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Price Type</label>
                        <b-form-select v-model="price_type" :options="priceTypeOptions" class="form-control" @change="updateSalePreview"></b-form-select>
                      </div>
                      <div class="form-group mb-2">
                        <label>Unit Price</label>
                        <input :value="price" type="number" readonly class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <label>Quantity</label>
                        <input v-model="quantity" type="number" required min="1" class="form-control" @input="updateSalePreview" />
                      </div>
                      <div v-if="availabilityPreview" class="allocation-preview-panel mb-2">
                        <div class="allocation-preview-header">
                          <div class="allocation-preview-heading">
                            <div class="allocation-preview-icon-wrap">
                              <i class="mdi mdi-package-variant-closed"></i>
                            </div>
                            <div class="allocation-preview-title">Batch Allocation Preview</div>
                            <div class="allocation-preview-subtitle">
                              {{ availabilityPreview.available_units }} {{ selectedUnitLabel }} of live stock currently available
                            </div>
                          </div>
                          <div
                            class="allocation-preview-summary"
                            :class="availabilityPreview.can_fulfill ? 'allocation-preview-summary--ready' : 'allocation-preview-summary--blocked'"
                          >
                            {{ availabilityPreview.can_fulfill ? "Ready to sell" : "Needs attention" }}
                          </div>
                        </div>

                        <div
                          v-if="availabilityPreview.warnings && availabilityPreview.warnings.length"
                          class="allocation-preview-warning"
                        >
                          <div class="allocation-preview-warning-title">Important</div>
                          <div
                            v-for="(warning, index) in availabilityPreview.warnings"
                            :key="index"
                            class="allocation-preview-warning-line"
                          >
                            {{ warning }}
                          </div>
                        </div>

                        <div
                          v-if="availabilityPreview.allocations && availabilityPreview.allocations.length"
                          class="allocation-preview-list"
                        >
                          <div
                            v-for="allocation in availabilityPreview.allocations"
                            :key="allocation.batch_id"
                            class="allocation-preview-card"
                            :class="`allocation-preview-card--${getAllocationTone(allocation)}`"
                          >
                            <div class="allocation-preview-card-top">
                              <div class="allocation-preview-batch">
                                <span class="allocation-preview-batch-label">Batch</span>
                                <span class="allocation-preview-batch-number">{{ allocation.batch_number }}</span>
                              </div>
                              <div
                                class="allocation-preview-chip"
                                :class="`allocation-preview-chip--${getAllocationTone(allocation)}`"
                              >
                                {{ getAllocationMessage(allocation) }}
                              </div>
                            </div>

                            <div class="allocation-preview-card-body">
                              <div class="allocation-preview-hero">
                                <span class="allocation-preview-hero-icon">
                                  <i class="mdi mdi-arrow-up-bold-circle-outline"></i>
                                </span>
                                <div class="allocation-preview-hero-copy">
                                  <span class="allocation-preview-hero-label">Selling from this batch</span>
                                  <span class="allocation-preview-hero-value">
                                    {{ allocation.quantity_units }}
                                    <small>{{ selectedUnitLabel }}</small>
                                  </span>
                                </div>
                              </div>
                              <div class="allocation-preview-metrics">
                                <div class="allocation-preview-metric allocation-preview-metric--stock">
                                  <span class="allocation-preview-metric-icon">
                                    <i class="mdi mdi-archive-outline"></i>
                                  </span>
                                  <div class="allocation-preview-metric-copy">
                                    <span class="allocation-preview-metric-label">Remaining after sale</span>
                                    <span class="allocation-preview-metric-value">
                                      {{ formatAllocationUnits(allocation.remaining_after_base) }}
                                      <small>{{ selectedUnitLabel }}</small>
                                    </span>
                                  </div>
                                </div>
                                <div class="allocation-preview-metric allocation-preview-metric--expiry">
                                  <span class="allocation-preview-metric-icon">
                                    <i class="mdi mdi-calendar-clock-outline"></i>
                                  </span>
                                  <div class="allocation-preview-metric-copy">
                                    <span class="allocation-preview-metric-label">Expires</span>
                                    <span class="allocation-preview-metric-value allocation-preview-metric-value--expiry">
                                      {{ formatAllocationExpiry(allocation) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <b-button class="btn w-100" type="submit" variant="primary" :disabled="!canAddCurrentLine"><i class="fas fa-check-circle"></i> Add To Cart</b-button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <span v-if="this.salecarts.length<=0">
                    <div class="d-flex justify-content-center p-5">
                      <span class="mdi mdi-pill text-success display-5"></span><br>
                      <span class="h4 mt-4">No Item Selected</span>
                    </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table :items="Items" :fields="Fields" responsive="sm" :busy="IsBusy">
                        <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(product)="data">
                          {{ data.item.product.name }}
                        </template>
                        <template #cell(category)="data">
                          {{ data.item.category.name }}
                        </template>
                        <template #cell(unit)="data">
                          {{ data.item.unit.unit_name }}
                        </template>
                        <template #cell(price_type)="data">
                          {{ data.item.price_type }}
                        </template>
                        <template #cell(actions)="data">
                          <b-button @click="remove(data.item.id,data.item.product.name)" type="button" class="btn-sm btn" variant="danger" v-b-modal.delete>
                            <i class="mdi mdi-trash-can"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </div>
                    <div class="row mx-1">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Total</label>
                          <input :value="cart_total" type="number" readonly class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Amount Paid</label>
                          <input :value="cart_total" type="number" readonly class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Payment Option</label>
                          <multiselect v-model="payoption" label="name" :options="paymentoptions"></multiselect>
                        </div>
                      </div>
                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <label>Pay Date</label>
                          <input v-model="paydate" type="date" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div class="alert alert-info mt-4 mb-2" v-if="cartPreviewWarnings.length">
                          <div v-for="(warning, index) in cartPreviewWarnings" :key="index">{{ warning }}</div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <b-button class="btn w-100 mt-4 mb-2" @click="SubmitExit" variant="primary"><i class="mdi mdi-check-circle"></i> SUBMIT & EXIT</b-button>
                      </div>
                      <div class="col-md-4">
                        <b-button class="btn w-100 mt-4 mb-2" @click="SubmitPrint" variant="success"><i class="mdi mdi-printer"></i> SUBMIT & PRINT</b-button>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Sell Medicine</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="delete-unit" centered title="Delete From Cart" title-class="font-18" hide-footer>
      <form @submit.prevent="removeFromCart">
        <input v-model="id" type="hidden">
        Are you sure you want to remove the Product : <b>{{ productName }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> YES</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  paymentoptionMethods, paymentoptionComputed,
  productcategoryMethods, productcategoryComputed,
  salecartMethods, salecartComputed
} from "@/state/helpers";

export default {
  page: {
    title: "Sell Medicine",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader, Multiselect
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Sell Medicine",
      items: [{ text: "Dashboard", to: "/" }, { text: "Sell Medicine", active: true }],
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "category", label: "Category", visible: true },
        { key: "product", label: "Product Name", visible: true },
        { key: "unit", label: "Unit Name", visible: true },
        { key: "price_type", label: "Price Type", visible: true },
        { key: "price", label: "Price", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        { key: "actions", label: "Remove", visible: true },
      ],
      priceTypeOptions: [
        { value: "retail", text: "Retail" },
        { value: "wholesale", text: "Wholesale" },
      ],
      products: [],
      units: [],
      id: "",
      category: "",
      product: "",
      unit: "",
      price_type: "retail",
      price: "",
      quantity: "1",
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: "",
      productName: "",
      availabilityPreview: null,
      cartPreviewWarnings: [],
    };
  },
  computed: {
    ...salecartComputed,
    ...productcategoryComputed,
    ...paymentoptionComputed,
    cart_total() {
      return this.salecarts.reduce((total, item) => total + Number(item.price || 0) * Number(item.quantity || 0), 0);
    },
    Fields() { return this.fields.filter(field => field.visible); },
    Items() { return this.salecarts.map((d) => ({ ...d })); },
    Cart() {
      return this.salecarts.map((d) => ({
        id: d.id,
        unit: d.unit.id,
        product: d.product.id,
        quantity: d.quantity,
        price: d.price,
        price_type: d.price_type || "retail",
      }));
    },
    IsBusy() { return this.salecarts.length === 0; },
    canAddCurrentLine() {
      return !!(this.category && this.product && this.unit && this.price && this.availabilityPreview && this.availabilityPreview.can_fulfill);
    },
    selectedPayoptionId() {
      return this.payoption?.id || this.paymentoptions.find(option => option.set_default == 1)?.id || null;
    },
    selectedUnitLabel() {
      return this.unit?.unit || "units";
    },
    expiryPreviewWarnings() {
      if (!this.availabilityPreview?.allocations?.length) {
        return [];
      }
      return this.availabilityPreview.allocations
        .filter((allocation) => {
          const days = this.daysUntilDate(allocation.expiry_date);
          return allocation.expiry_date && days >= 0 && days <= 10;
        })
        .map((allocation) => {
          const days = this.daysUntilDate(allocation.expiry_date);
          return `Batch ${allocation.batch_number} is expiring in ${days} day${days === 1 ? "" : "s"}.`;
        });
    },
  },
  mounted() {
    this.fetchPaymentoptions();
    this.fetchSalesCart();
    this.fetchCategories();
    this.isBusy = false;
    this.payoption = this.paymentoptions.find(option => option.set_default == 1);
  },
  methods: {
    ...salecartMethods,
    ...productcategoryMethods,
    ...paymentoptionMethods,
    remove(id, productName) {
      this.id = id;
      this.productName = productName;
      this.$bvModal.show("delete-unit");
    },
    async FilterProducts() {
      const response = await axios.get(`/productbycategory/${this.category.id}`);
      this.products = response.data.products;
      this.product = "";
      this.unit = "";
      this.availabilityPreview = null;
    },
    async FilterProductUnits() {
      const response = await axios.get(`/unitsbyproduct/${this.product.id}`);
      this.units = response.data.units;
      this.unit = "";
      this.price = "";
      this.availabilityPreview = null;
    },
    daysUntilDate(dateValue) {
      if (!dateValue) return null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const target = new Date(dateValue);
      target.setHours(0, 0, 0, 0);
      return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
    },
    formatHumanDate(dateValue) {
      if (!dateValue) return "";
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) {
        return dateValue;
      }
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    formatAllocationUnits(baseQuantity) {
      if (!this.unit?.base_quantity) {
        return baseQuantity;
      }
      return Math.floor(Number(baseQuantity || 0) / Math.max(1, Number(this.unit.base_quantity)));
    },
    getAllocationTone(allocation) {
      const days = this.daysUntilDate(allocation.expiry_date);
      if (allocation.is_legacy_opening) return "legacy";
      if (days === null) return "stable";
      if (days < 0) return "danger";
      if (days <= 10) return "warning";
      return "stable";
    },
    getAllocationMessage(allocation) {
      const days = this.daysUntilDate(allocation.expiry_date);
      if (allocation.is_legacy_opening) return "Legacy stock";
      if (days === null) return "No expiry date";
      if (days < 0) return "Expired batch";
      if (days === 0) return "Expires today";
      if (days <= 10) return `${days} day${days === 1 ? "" : "s"} left`;
      return "Batch okay";
    },
    formatAllocationExpiry(allocation) {
      const days = this.daysUntilDate(allocation.expiry_date);
      if (allocation.is_legacy_opening && !allocation.expiry_date) {
        return "Legacy opening stock";
      }
      if (!allocation.expiry_date) {
        return "Not recorded";
      }
      if (days !== null && days >= 0 && days <= 10) {
        return `${this.formatHumanDate(allocation.expiry_date)} • ${days} day${days === 1 ? "" : "s"} remaining`;
      }
      if (days !== null && days < 0) {
        return `${this.formatHumanDate(allocation.expiry_date)} • expired`;
      }
      return this.formatHumanDate(allocation.expiry_date);
    },
    resetEntryForm() {
      this.category = "";
      this.product = "";
      this.unit = "";
      this.price_type = "retail";
      this.price = "";
      this.quantity = "1";
      this.availabilityPreview = null;
    },
    buildExpiryNotificationPayload(allocation, days) {
      return {
        title: "Expiring stock warning",
        productName: this.product?.name || null,
        batchNumber: allocation?.batch_number || null,
        details: [
          this.product?.name ? `Product: ${this.product.name}` : null,
          allocation?.batch_number ? `Batch: ${allocation.batch_number}` : null,
          allocation?.expiry_date ? `Expiry date: ${this.formatHumanDate(allocation.expiry_date)}` : null,
          days !== null && days !== undefined ? `Expires in ${days} day${days === 1 ? "" : "s"}` : null,
        ],
      };
    },
    async updateSalePreview() {
      if (!this.product || !this.unit || !this.quantity) {
        this.availabilityPreview = null;
        this.price = "";
        return;
      }
      const response = await axios.post("/saleallocationpreview", {
        product: this.product.id,
        unit: this.unit.unit_id,
        quantity: this.quantity,
        price_type: this.price_type,
      });
      this.availabilityPreview = response.data.preview;
      this.price = response.data.unit_price;
    },
    async AddtoCart() {
      await this.updateSalePreview();
      if (!this.availabilityPreview?.can_fulfill) {
        this.$toast.error("Requested quantity exceeds available live stock.");
        return;
      }
      if (this.expiryPreviewWarnings.length) {
        const expiringAllocation = (this.availabilityPreview.allocations || []).find((allocation) => {
          const days = this.daysUntilDate(allocation.expiry_date);
          return allocation.expiry_date && days >= 0 && days <= 10;
        });
        const days = expiringAllocation ? this.daysUntilDate(expiringAllocation.expiry_date) : null;
        this.$toast.warning(this.expiryPreviewWarnings[0], {
          notificationCenter: this.buildExpiryNotificationPayload(expiringAllocation, days),
        });
      }
      const formData = new FormData();
      formData.append("category", this.category.id);
      formData.append("product", this.product.id);
      formData.append("unit", this.unit.unit_id);
      formData.append("price", this.price);
      formData.append("quantity", this.quantity);
      formData.append("price_type", this.price_type);
      await axios.post("/addtocart", formData);
      this.payoption = this.paymentoptions.find(option => option.set_default == 1);
      this.fetchSalesCart();
      this.resetEntryForm();
    },
    async removeFromCart() {
      const formData = new FormData();
      formData.append("id", this.id);
      await axios.post("/deletefromcart", formData);
      this.fetchSalesCart();
      this.$bvModal.hide("delete-unit");
    },
    async refreshCartWarnings() {
      const warnings = [];
      let hasBlockingIssue = false;
      for (const item of this.Cart) {
        const response = await axios.post("/saleallocationpreview", {
          product: item.product,
          unit: item.unit,
          quantity: item.quantity,
          price_type: item.price_type,
        });
        if (!response.data.preview.can_fulfill) {
          hasBlockingIssue = true;
          warnings.push(`Only ${response.data.preview.available_units} live units are available for one of the selected items.`);
        }
        warnings.push(...(response.data.preview.warnings || []));
        (response.data.preview.allocations || []).forEach((allocation) => {
          const days = this.daysUntilDate(allocation.expiry_date);
          if (allocation.expiry_date && days >= 0 && days <= 10) {
            warnings.push(`Batch ${allocation.batch_number} is expiring in ${days} day${days === 1 ? "" : "s"}.`);
          }
        });
      }
      this.cartPreviewWarnings = [...new Set(warnings)];
      return !hasBlockingIssue;
    },
    async SubmitExit() {
      const canProceed = await this.refreshCartWarnings();
      if (!canProceed) {
        this.$toast.error("Please reduce the affected quantity before submitting the sale.");
        return;
      }
      if (!this.selectedPayoptionId) {
        this.$toast.error("Please select a payment option before submitting the sale.");
        return;
      }
      const obj = { cart: this.Cart, amount: this.cart_total, total: this.cart_total, payoption: this.selectedPayoptionId, paydate: this.paydate };
      await axios.post("/savecart", obj);
      this.fetchSalesCart();
      this.$toast.success("New Medicine Sale Added");
    },
    async SubmitPrint() {
      const canProceed = await this.refreshCartWarnings();
      if (!canProceed) {
        this.$toast.error("Please reduce the affected quantity before printing.");
        return;
      }
      if (!this.selectedPayoptionId) {
        this.$toast.error("Please select a payment option before printing.");
        return;
      }
      const obj = { cart: this.Cart, amount: this.cart_total, total: this.cart_total, payoption: this.selectedPayoptionId, paydate: this.paydate };
      const response = await axios.post("/savecart", obj);
      this.$router.push({ path: "/printreciept", query: { id: response.data } });
    }
  },
};
</script>

<style scoped>
.allocation-preview-panel {
  padding: 0.85rem;
  border: 1px solid #dce7e1;
  border-radius: 22px;
  background:
    radial-gradient(circle at top right, rgba(245, 158, 11, 0.18), transparent 28%),
    radial-gradient(circle at top left, rgba(15, 118, 110, 0.12), transparent 34%),
    linear-gradient(180deg, #ffffff 0%, #f7fbf9 100%);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.allocation-preview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.7rem;
  margin-bottom: 0.7rem;
}

.allocation-preview-heading {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    "icon title"
    "icon subtitle";
  column-gap: 0.75rem;
  row-gap: 0.12rem;
}

.allocation-preview-icon-wrap {
  grid-area: icon;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  font-size: 1rem;
  box-shadow: 0 10px 24px rgba(20, 184, 166, 0.28);
}

.allocation-preview-title {
  grid-area: title;
  font-size: 0.88rem;
  font-weight: 800;
  color: #0f172a;
}

.allocation-preview-subtitle {
  grid-area: subtitle;
  margin-top: 0.05rem;
  font-size: 0.74rem;
  color: #52606d;
}

.allocation-preview-summary {
  padding: 0.34rem 0.68rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  white-space: nowrap;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.24);
}

.allocation-preview-summary--ready {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #166534;
}

.allocation-preview-summary--blocked {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #b91c1c;
}

.allocation-preview-warning {
  margin-bottom: 0.7rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid #fdba74;
  border-radius: 18px;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  box-shadow: 0 10px 24px rgba(251, 146, 60, 0.14);
}

.allocation-preview-warning-title {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #c2410c;
}

.allocation-preview-warning-line {
  margin-top: 0.22rem;
  font-size: 0.75rem;
  line-height: 1.35;
  color: #9a3412;
}

.allocation-preview-list {
  display: grid;
  gap: 0.55rem;
}

.allocation-preview-card {
  position: relative;
  padding: 0.72rem 0.78rem 0.72rem 0.95rem;
  border: 1px solid #dcebe5;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.allocation-preview-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 6px;
  border-radius: 20px 0 0 20px;
}

.allocation-preview-card--stable::before {
  background: linear-gradient(180deg, #22c55e 0%, #16a34a 100%);
}

.allocation-preview-card--warning::before {
  background: linear-gradient(180deg, #fb923c 0%, #ea580c 100%);
}

.allocation-preview-card--danger::before {
  background: linear-gradient(180deg, #f87171 0%, #dc2626 100%);
}

.allocation-preview-card--legacy::before {
  background: linear-gradient(180deg, #a78bfa 0%, #7c3aed 100%);
}

.allocation-preview-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
}

.allocation-preview-batch {
  min-width: 0;
}

.allocation-preview-batch-label {
  display: block;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
}

.allocation-preview-batch-number {
  display: block;
  margin-top: 0.08rem;
  font-size: 1rem;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
  word-break: break-word;
}

.allocation-preview-chip {
  flex: 0 0 auto;
  padding: 0.28rem 0.56rem;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 800;
  white-space: nowrap;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.26);
}

.allocation-preview-chip--stable {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #166534;
}

.allocation-preview-chip--warning {
  background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);
  color: #c2410c;
}

.allocation-preview-chip--danger {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #b91c1c;
}

.allocation-preview-chip--legacy {
  background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
  color: #6d28d9;
}

.allocation-preview-card-body {
  margin-top: 0.7rem;
  display: grid;
  gap: 0.55rem;
}

.allocation-preview-hero {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.7rem 0.85rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid #a7f3d0;
}

.allocation-preview-hero-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  font-size: 1.15rem;
  background: #ffffff;
  color: #15803d;
  box-shadow: 0 6px 14px rgba(16, 185, 129, 0.18);
}

.allocation-preview-hero-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.allocation-preview-hero-label {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #047857;
}

.allocation-preview-hero-value {
  margin-top: 0.1rem;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.15;
  color: #064e3b;
}

.allocation-preview-hero-value small {
  margin-left: 0.25rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #065f46;
}

.allocation-preview-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.allocation-preview-metric {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.6rem 0.7rem;
  border-radius: 14px;
  border: 1px solid #e4eeea;
  background: #f8fbfa;
  min-width: 0;
}

.allocation-preview-metric-icon {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  font-size: 0.9rem;
}

.allocation-preview-metric-copy {
  min-width: 0;
}

.allocation-preview-metric--stock .allocation-preview-metric-icon {
  background: #dbeafe;
  color: #1d4ed8;
}

.allocation-preview-metric--expiry .allocation-preview-metric-icon {
  background: #ffedd5;
  color: #c2410c;
}

.allocation-preview-metric-label {
  display: block;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6b7280;
  line-height: 1.3;
}

.allocation-preview-metric-value {
  display: block;
  margin-top: 0.18rem;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.3;
  color: #1f2937;
  word-break: break-word;
}

.allocation-preview-metric-value small {
  margin-left: 0.2rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
}

.allocation-preview-metric-value--expiry {
  font-size: 0.78rem;
}

@media (max-width: 767px) {
  .allocation-preview-header,
  .allocation-preview-card-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .allocation-preview-summary,
  .allocation-preview-chip {
    white-space: normal;
  }

  .allocation-preview-metrics {
    grid-template-columns: 1fr;
  }
}
</style>
